import {useEffect, useState} from "react"
import {getCondoById} from "@/api/condo"

type PropertyZoneSource = {
   zone?: string | null
   condo?: string | null
}

export function useResolvedPropertyZone(property?: PropertyZoneSource | null) {
   const [condoZone, setCondoZone] = useState<string | null>(null)

   useEffect(() => {
      let canceled = false

      const resolveZone = async () => {
         if (!property || property.zone || !property.condo) {
            setCondoZone(null)
            return
         }

         try {
            const condo = await getCondoById(property.condo)
            if (!canceled) setCondoZone(condo?.zone ?? null)
         } catch {
            if (!canceled) setCondoZone(null)
         }
      }

      resolveZone()

      return () => {
         canceled = true
      }
   }, [property])

   return property?.zone ?? condoZone
}
